import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dialog",
    "locationName",
    "landmark",
    "address",
    "mapLink",
    "contactLink"
  ]

  connect() {
    this.boundCloseOnBackdrop = this.closeOnBackdrop.bind(this)
  }

  disconnect() {
    if (this.hasDialogTarget) {
      this.dialogTarget.removeEventListener("click", this.boundCloseOnBackdrop)
    }
  }

  open(event) {
    event.preventDefault()
    if (!this.hasDialogTarget) return

    const locationName = event.params.location || "Studio"
    if (this.hasLocationNameTarget) {
      this.locationNameTarget.textContent = locationName
    }
    if (this.hasLandmarkTarget) {
      this.landmarkTarget.textContent = event.params.landmark || "-"
    }
    if (this.hasAddressTarget) {
      this.addressTarget.textContent = event.params.address || "-"
    }
    if (this.hasMapLinkTarget) {
      const mapUrl = event.params.mapUrl || "#"
      this.mapLinkTarget.href = mapUrl
      this.mapLinkTarget.classList.toggle("pointer-events-none", mapUrl === "#")
      this.mapLinkTarget.classList.toggle("text-gray-400", mapUrl === "#")
    }
    if (this.hasContactLinkTarget) {
      const countryCode = event.params.countryCode || ""
      const contactNumber = event.params.contactNumber || ""
      const fullContact = [countryCode, contactNumber].filter(Boolean).join(" ").trim()
      this.contactLinkTarget.textContent = fullContact || "-"
      this.contactLinkTarget.href = contactNumber ? `tel:${contactNumber}` : "#"
      this.contactLinkTarget.classList.toggle("pointer-events-none", !contactNumber)
      this.contactLinkTarget.classList.toggle("text-gray-400", !contactNumber)
    }

    this.dialogTarget.showModal()
    this.dialogTarget.addEventListener("click", this.boundCloseOnBackdrop)
  }

  close(event) {
    if (event) event.preventDefault()
    if (!this.hasDialogTarget || !this.dialogTarget.open) return

    this.dialogTarget.removeEventListener("click", this.boundCloseOnBackdrop)
    this.dialogTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }
}
